import { string, number, boolean } from 'yup'

export const name = string()
  .min(3, 'O nome deve conter ao menos 3 letras')
  .required('O campo é obrigatório')

export const phone = string()
  .min(11, 'O número de telefone está incompleto')
  .required('O campo é obrigatório')

export const simulatorAge = number()
  .integer('O valor não deve conter vírgulas ou pontos')
  .max(120, 'A idade máxima é 120 anos')
  .required('O campo é obrigatório')
  .transform(value => (isNaN(value) ? undefined : value))

export const postalCode = string()
  .min(8, 'O CEP está incompleto')
  .required('O campo é obrigatório')

export const email = string()
  .email('E-mail inválido')
  .required('O campo é obrigatório')
  .test({
    name: 'email',
    message: 'E-mail inválido',
    test: (value = '') => {
      return isValidBrazilEmailFormat(value)
    }
  })

export const cnpj = string()
  .required('O campo é obrigatório')
  .test({
    name: 'cnpj',
    message: 'CNPJ inválido',
    test: (value = '') => {
      return isCNPJ(value)
    }
  })

export const requiredBooleanValue = boolean().required('O campo é obrigatório')

export const stringValue = string()

export const requiredStringValue = string().required('O campo é obrigatório')

/**
 * Validate if a value number is CNPJ
 *
 * @param {string} value CNPJ (ex: 14.572.457.0001-85)
 *
 */
export const isCNPJ = (value: string): boolean => {
  value = value.replace(/[^\d]+/g, '')

  if (value == '') return false

  if (value.length != 14) return false

  // Eliminates known invalid CNPJs
  if (
    value == '00000000000000' ||
    value == '11111111111111' ||
    value == '22222222222222' ||
    value == '33333333333333' ||
    value == '44444444444444' ||
    value == '55555555555555' ||
    value == '66666666666666' ||
    value == '77777777777777' ||
    value == '88888888888888' ||
    value == '99999999999999'
  )
    return false

  const calculateVerifyingDigit = (position: number): number => {
    const numbers = value.substring(0, position)
    let sum = 0
    let weight = position - 7

    for (let i = position; i >= 1; i--) {
      sum += parseInt(numbers.charAt(position - i)) * weight--
      if (weight < 2) weight = 9
    }

    const rest = sum % 11
    return rest < 2 ? 0 : 11 - rest
  }

  const digits = value.substring(12)

  //Validate first DV
  const firstDigit = calculateVerifyingDigit(12)
  if (firstDigit != parseInt(digits.charAt(0))) return false

  //Validate secont DV
  const secondDigit = calculateVerifyingDigit(13)
  if (secondDigit != parseInt(digits.charAt(1))) return false

  return true
}

export const isValidBrazilEmailFormat = (value: string): boolean => {
  return (
    /^[^\s@]+@[^\s@]+\.com$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.com\.[a-zA-Z]{2,}$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.gov\.br$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.org(\.[a-zA-Z]{2,})?$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.net$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.edu\.br$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.mil\.br$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.leg\.br$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.jus\.br$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.br$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.pro$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.cloud$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.ai$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.io$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.co$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.tech$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.app$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.dev$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.digital$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.solutions$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.services$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.studio$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.health$/.test(value) ||
    /^[^\s@]+@[^\s@]+\.care$/.test(value) ||
    /^[^\s@]+@locus\.software$/.test(value)
  )
}
